"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.19.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreaterThanFieldEnum = void 0;
exports.GreaterThanFieldEnum = {
    Date: 'date',
    Id: 'id',
    Name: 'name',
    Status: 'status',
    Code: 'code',
    TotalInCents: 'total_in_cents',
    OrderItemsAvailabilityId: 'order_items.availability_id',
    OrderItemsExperienceId: 'order_items.experience_id',
    OrderItemsEntryCode: 'order_items.entry_code',
    OrderItemsOrderItemType: 'order_items.order_item_type',
    OrderItemsId: 'order_items.id',
    OrderItemsContactEmail: 'order_items.contact.email',
    OrderItemsContactFullName: 'order_items.contact.full_name',
    OrderItemsRedeemCode: 'order_items.redeem_code',
    OrderItemsInitialValue: 'order_items.initial_value',
    OrderItemsProduct: 'order_items.product'
};
